import React from 'react'

export default function PhysicalForm () {
  return (
 <> <div className='pscreen-section pscreen-section--official'>
                <div className='section-header section-header--assessor'>
                  <h2>Section B: Physical Screening by Police Assessor</h2>
                  <span className='section-badge'>Assessor Only</span>
                </div>

                <p className='section-note'>Enter A = Pass or B = Fail</p>

                <table className='credentials-table'>
                  <tbody>
                    {/* English and Mathematics */}
                    <tr>
                      <td className='credentials-table__label '>Height:</td>
                      <td className='credentials-table__field credentials-table__field--short'></td>
                      <td className='credentials-table__label'>Chest Expansion (Males Only):</td>
                      <td className='credentials-table__field credentials-table__field--short'></td>
                    </tr>

                    {/* Subject 3 and Subject 4 */}
                    <tr>
                      <td className='credentials-table__label'>Speech Impediment:</td>
                      <td className='credentials-table__field'></td>
                      <td className='credentials-table__label'>Amputation of any kind:</td>
                      <td className='credentials-table__field credentials-table__field--short'></td>
                    </tr>
                    <tr>
                      <td className='credentials-table__label'>Amputation of any kind:</td>
                      <td className='credentials-table__field'></td>
                      <td className='credentials-table__label'>Tattoo:</td>
                      <td className='credentials-table__field credentials-table__field--short'></td>
                    </tr>

                    {/* Subject 5 and SSCE Certificate Year */}
                    <tr>
                      <td className='credentials-table__label'>Bow Legs:</td>
                      <td className='credentials-table__field'></td>
                      <td className='credentials-table__label'>Malformation of Teeth:</td>
                      <td className='credentials-table__field credentials-table__field--short'></td>
                    </tr>
                    <tr>
                      <td className='credentials-table__label'>Flat Feet:</td>
                      <td className='credentials-table__field'></td>
                                            <td className='credentials-table__label'>Squint Eyes:</td>
                      <td className='credentials-table__field'></td>
                    </tr>

                    {/* Guarantors Form and Valid NIN Printout */}
                    <tr>

                      <td className='credentials-table__label'>Deformed Limb(s):</td>
                      <td className='credentials-table__field'></td>
                                            <td className='credentials-table__label'>Obesity:</td>
                      <td className='credentials-table__field'></td>
                    </tr>

                    {/* Comments */}
                    <tr>
                      <td className='credentials-table__label credentials-table__label--top' colSpan={4}>
                        Comments (especially if any faults/alterations):
                      </td>
                    </tr>
                    <tr>
                      <td className='credentials-table__field credentials-table__field--comments' colSpan={4}>
                        <div className='credentials-table__comment-lines my-2'>
                          <div className='my-4'></div>
                          {/* <div className='my-2'></div>
                          <div className='my-2'></div> */}
                        </div>
                      </td>
                    </tr>

                    {/* Assessor Name and Signature */}
                    <tr>
                      <td className='credentials-table__label'>Name of Assessor:</td>
                      <td className='credentials-table__field'></td>
                      <td className='credentials-table__label'>Rank of Assessor:</td>
                      <td className='credentials-table__field'></td>
                    </tr>

                        <tr>
                      <td className='credentials-table__label'>Sign:</td>
                      <td className='credentials-table__field'></td>
                      <td className='credentials-table__label'>Date:</td>
                      <td className='credentials-table__field'></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className='pscreen-section pscreen-section--official'>
                <div className='section-header section-header--teamlead'>
                  <h2>Section C: Final Endorsement by Team Lead</h2>
                  <span className='section-badge'>Official Only</span>
                </div>

                <p className='section-note'>
                  For official use only (A = Pass/Recommended, B = Fail/Not Recommended)
                </p>

                <div className='manual-form-grid'>
                  <div className='manual-row manual-row--wide'>
                    <label className='manual-label'>
                      (NPF TEAM LEAD) Officer Name/Signature:
                    </label>
                    <div className='manual-line-long'></div>
                    <label className='manual-label ml-3'>Recommendation:</label>
                    <div className='manual-line-short'></div>
                  </div>

                  <div className='manual-row manual-row--full'>
                    <label className='manual-label'>Comments (if any):</label>
                    <div className='manual-multiline my-2'>
                      <div className='manual-line my-3'></div>
                      {/* <div className='manual-line my-3'></div> */}
                    </div>
                  </div>

                  {/* <div className='manual-row'>
                    <label className='manual-label'>Date:</label>
                    <div className='manual-line'></div>
                  </div> */}
                </div>
              </div>
              </>
  )
}
